import {partition} from 'lodash';
import React, {FC} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {AttachmentModel} from '../../../models/api/attachmentModel';
import {
  attachmentSpacing,
  MessageAttachment,
} from '../../inboxes/viewer/activity/attachments/messageAttachment';

/*
 * Props.
 */

export interface AttachmentsEditorProps {
  attachments: ReadonlyArray<AttachmentModel>;
  onRemoveAttachmentClick: HandlerOf<string>;
  onCancelAttachmentUploadClick: HandlerOf<string>;
}

/*
 * Styles.
 */

const StyledWrapperDiv = styled.div`
  padding-left: ${attachmentSpacing}px;

  display: flex;
  flex-wrap: wrap;
`;

/*
 * Component.
 */

export const AttachmentsEditor: FC<AttachmentsEditorProps> = (props) => {
  // We need at least one attachment to render.
  if (props.attachments.length === 0) {
    return null;
  }

  const [giphyAttachments, nonGiphyAttachments] = partition(
    props.attachments,
    (a) => a.giphyId !== undefined,
  );

  return (
    <>
      {giphyAttachments.length > 0 && (
        <StyledWrapperDiv>{giphyAttachments.map((a) => renderAttachment(a, props, true))}</StyledWrapperDiv>
      )}
      {nonGiphyAttachments.length > 0 && (
        <StyledWrapperDiv>
          {nonGiphyAttachments.map((a) => renderAttachment(a, props, false))}
        </StyledWrapperDiv>
      )}
    </>
  );
};

/*
 * Helpers.
 */

function renderAttachment(
  attachment: AttachmentModel,
  props: AttachmentsEditorProps,
  hasLargeAttachmentView: boolean,
) {
  return (
    <MessageAttachment
      hasLargeAttachmentView={hasLargeAttachmentView}
      key={attachment.cid}
      attachment={attachment}
      onRemoveClick={() => props.onRemoveAttachmentClick(attachment.cid)}
      onCancelUploadClick={() => props.onCancelAttachmentUploadClick(attachment.cid)}
      canBeRemoved
    />
  );
}
